window.moment = require('moment');
window.moment.locale('pt-br');

const state = {
    calltime: 'null',
    settings: {
        tab: false,
        tab: "toogle",
        filter: "all",
    }
}

const getters = {
    getRealTime: state => state.realtime,
    getCallTime: state => state.calltime,
    getSettings: state => state.settings,
}

const mutations = {
    setNewCallTime: (state, time) => (state.calltime = time),
    setNewSettings: (state, setting) => (state.settings = setting),
}

const actions = {
    async setCallTime({ commit }, data) {
        commit('setNewCallTime', data);
    },
    async setSettings({ commit }, data) {
        commit('setNewSettings', data);
    },
    async login(data) {
        socket.emit('queueLogin', {
            extension: data.getters.getExtension(),
            queue: data.getters.getQueues
        });
    },
    async ouvir(data) {
        socket.on(`QueueMemberAdded-${data.getters.getExtension()}`, () => { });
    }
}

export default {
    getters,
    mutations,
    actions,
    state
}